<template>
  <div class="container justify-content-center mt-5">
    <div
      class="
        row
        d-flex
        justify-content-center
        company-product-payment-success-page
      "
    >
      <div class="col-md-8 mt-3">
        <h3 class="text-center mb-4 page-title">{{ $t(LangConstants.thanks_for_order_heading) }}</h3>
        <p class="mb-5 text-center page-desc">
          {{ $t(LangConstants.order_confirmation_mail_sent_text) }}
        </p>

        <div class="row form-base order-info-entitites pl-3 pr-3 mb-4">
          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.order_number_text) }}</span>
            <span class="value">{{ this.subscriptionId }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.product_text) }}</span>
            <span class="value">{{ productName }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.domain_text) }}</span>
            <span class="value">{{ this.subdomain }}.sparkfore.com</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.payment_period_text) }}</span>
            <span class="value">{{ this.productInterval }}</span>
          </div>

          <div class="col-md-6 order-info-entity mb-4">
            <span class="header mb-2">{{ $t(LangConstants.total_cost_text) }}</span>
            <span class="value">{{ this.totalCost }}</span>
          </div>
        </div>

        <div class="row form-base pl-3 pr-3 mb-4 redirect-home">
          <div class="col-md-12 order-info-entity mb-4">
            <div class="row mb-4">
              <div class="col-auto">
                <i class="fa fa-building" aria-hidden="true"></i>
              </div>
              <div class="col text">
                {{ $t(LangConstants.customer_pages_heading) }}
                <div class="description">
                  {{ $t(LangConstants.customer_pages_text) }}
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <my-button fa="bars" :label="$t(LangConstants.open_button_label)" variant="solid-secondary" classes="mr-1" height="56px" width="100%"></my-button>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center">
            <div class="mb-2">
              <my-button fa="" :label="$t(LangConstants.contact_us_button_label)" variant="box-primary" classes="mr-1" height="64px" minwidth="400px"></my-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * Customer Payment Success Page
 */
import "../../../assets/scss/companyproductpaymentsuccesspage.scss";
import MyButton from "../../../components/atoms/Button.vue";
import common from "../../../functions/index";
import Constants from "../../../constants/index";

export default {
  name: "make-payment-success",
  async created() {
    try {
      const trType = this.$route.params.type;
      this.subscriptionId = null;

      switch (trType) {
        case "subscription":
          {
            this.subscriptionId = this.$route.params.id;
          }
          break;
        case "card":
          {
            var sessData = await this.$store.dispatch("getStripeCheckoutSession", { id: this.$route.params.id });

            sessData = JSON.parse(JSON.stringify(sessData));
            this.subdomain = sessData["metadata"]["subdomain"];
            this.productName = sessData["metadata"]["product"];
            this.subscriptionId = sessData["subscription"];
          }

          break;
      }

      if (this.subscriptionId == null || !this.subscriptionId) {
        this.$fire({
          title: this.$t(this.LangConstants.error_retrieving_subscription_heading),
          text: this.$t(this.LangConstants.no_subscription_id_message),
          type: "error",
          html: "",
        });
      } else {
        let subscriptionData = await this.$store.dispatch("getStripeSubscriptionById", this.subscriptionId);

        subscriptionData = JSON.parse(JSON.stringify(subscriptionData));

        if (this.subdomain == null || !this.subdomain) {
          this.subdomain = subscriptionData["metadata"]["subdomain"];
          this.productName = subscriptionData["metadata"]["product"];
        }

        this.totalCost = subscriptionData["plan"]["amount"] + " " + subscriptionData["plan"]["currency"];
        this.productInterval = common.getIntervalByNoun(subscriptionData["plan"]["interval"]);
        // this.productName = session.data.line_items.data[0].description
        // this.productInterval = this.intervals[session.data.line_items.data[0].price.recurring.interval];

        let formData = common.getFromLocalStorage(this.$route.params.id);

        if (formData != null) {
          formData["payment"] = subscriptionData;

          this.$store
            .dispatch("createCustomerInstance", formData)
            .then((result) => {
              common.deleteFromLocalStorage(this.$route.params.id);
              console.log(result);
            })
            .catch((error) => {
              this.$fire({
                title: this.$t(this.LangConstants.subscription_status_error_heading),
                text: this.$t(this.LangConstants.customer_instance_creation_failed_message),
                type: "error",
                html: "<div>" + this.$t(error) + "</div>",
              });
            });
        }
      }
    } catch (error) {
      this.$fire({
        title: this.$t(this.LangConstants.subscription_status_error_heading),
        text: this.$t(this.LangConstants.stripe_api_error_text),
        type: "error",
        html: "",
      });
    }

    // .then((session) => {

    //     console.log(session);

    //   if (session.success == true){
    //       this.productName = session.data.line_items.data[0].description
    //       this.productInterval = this.intervals[session.data.line_items.data[0].price.recurring.interval];
    //     }else{
    //       this.$fire({
    //         title: "Something Went Wrong",
    //         text: "Please try again",
    //         type: "error",
    //         html: "",
    //       });
    //     }
    // });
  },
  computed: {
    LangConstants() {
      return Constants;
    },
  },
  data() {
    return {
      productName: "",
      productInterval: "",
      orderNumber: "",
      subdomain: null,
      totalCost: "",
      subscriptionId: null,
    };
  },
  components: {
    MyButton,
  },
};
</script>
